import {
  generatePath as generateRoutePath,
  useParams as useRouterParams,
} from "react-router";

type PathParams<Path> = Path extends `:${infer Param}/${infer Rest}`
  ? Param | PathParams<Rest>
  : Path extends `:${infer Param}`
    ? Param
    : Path extends `${infer _Prefix}:${infer Rest}`
      ? PathParams<`:${Rest}`>
      : never;

type PathArgs<
  TPath,
  TParams = { [K in PathParams<TPath>]: string | number },
> = TParams;

export const routes = {
  home: "/",
  information: "/information",
  tournament: "/turneringar/:tournamentId",
  tournamentGroup: "/turneringar/:tournamentId/grupper/:groupId",
  tournamentGroupRound:
    "/turneringar/:tournamentId/grupper/:groupId/ronder/:round",
  matches: "/matcher",
  match: "/matcher/:matchId",
  game: "/matcher/:matchId/partier/:board",
  team: "/turneringar/:tournamentId/lag/:teamId",
  reg: "/anmalan",
  regTeam: "/anmal-klubb/:memberId",
  createClub: "/anmalan/skapa-klubb",
  myPage: "/min-sida/:memberId",
  membersWithoutTeamsPage: "/medlemmar-utan-lag",
  schoolStats: "/skolor",
  schoolDetail: "/skolor/:schoolId",
} as const;

type Routes = typeof routes;
type RouteKey = keyof Routes;

export function useParams<TRouteKey extends RouteKey>() {
  return useRouterParams<PathParams<Routes[TRouteKey]>>();
}

export function generatePath<TRouteKey extends RouteKey>(
  route: TRouteKey,
  params: PathArgs<Routes[TRouteKey]>,
) {
  // @ts-ignore
  return generateRoutePath(routes[route], params);
}
